
interface Props{
    quantity?: number
    loading: boolean
}
export function CommentsPlaceholder({ quantity = 6, loading }: Props){
    return (
        <>
            {loading ? (
                <>
                    {[...Array(quantity)].map((_, index) => (
                        <div className="row card-comment card-comment-modal">
                            <span className="user-select-none col-1 img-account-comment placeholder"/>
                            <div className="col" style={{ paddingLeft: "5px", overflow: "hidden",  }}>
                                <h5 className="h5-name-search name-card-search-user" style={{ overflowWrap: "anywhere", whiteSpace: "nowrap", overflow: "hidden", marginBottom: "2px" }}>
                                    <span className="name-search" style={{ marginRight: 5 }}>
                                    <div className="placeholder" style={{height: "10px", width: "90%"}}></div>
                                    </span>
                                </h5>
                                <p className="username-search" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                                    <span className="placeholder mt-1" style={{height: "10px", width: "100px"}}></span>
                                </p>
                            </div>
                        </div>
                    ))}
                </>
            ) : null }
        </>
    );
}